import {workflowCspOneDowngradeCuRouting} from "./workflow-csp-one-downgrade-cu/workflow-csp-one-downgrade-cu.routing";
import {workflowCspOneUpgradeCuRouting} from "./workflow-csp-one-upgrade-cu/workflow-csp-one-upgrade-cu.routing";
import {workflowCspOneUpgradeSlaRouting} from "./workflow-csp-one-upgrade-sla/workflow-csp-one-upgrade-sla.routing";
import {
  workflowCspOneDowngradeSlaRouting
} from "./workflow-csp-one-downgrade-sla/workflow-csp-one-downgrade-sla.routing";
import {workflowCspOneTrialCreateRouting} from "./workflow-csp-one-trial-create/workflow-csp-one-trial-create.routing";
import {workflowCspAddTrialPhonenumberRouting} from "./workflow-csp-add-trial-phonenumber/workflow-csp-add-trial-phonenumber.routing";
import { WorkflowCspOneAvailabilityOrderCancelRouting } from "./workflow-csp-one-availability-order-cancel/workflow-csp-one-availability-order-cancel.routing";
import { workflowCspOneAvailabilityRouting } from "./workflow-csp-one-availability/workflow-csp-one-availability.routing";
import { workflowCspOneTariffRouting } from "./workflow-csp-one-tariff/workflow-csp-one-tariff.routing"
import { WorkflowCspOneTariffOrderCancelRouting } from "./workflow-csp-one-tariff-order-cancel/workflow-csp-one-tariff-order-cancel.routing";
import { workflowCspOneCancelPhonenumberRouting } from "./workflow-csp-one-cancel-phonenumber/workflow-csp-one-cancel-phonenumber.routing";
import { workflowCspAiTariffRouting } from "./workflow-csp-ai-tariff/workflow-csp-ai-tariff.routing";
import { WorkflowCspAiTariffOrderCancelRouting } from "./workflow-csp-ai-tariff-order-cancel/workflow-csp-ai-tariff-order-cancel.routing";

export const workflowCspRouting = [
  ...workflowCspOneUpgradeCuRouting,
  ...workflowCspOneUpgradeSlaRouting,
  ...workflowCspOneDowngradeCuRouting,
  ...workflowCspOneDowngradeSlaRouting,
  ...workflowCspOneTrialCreateRouting,
  ...workflowCspAddTrialPhonenumberRouting,
  ...WorkflowCspOneAvailabilityOrderCancelRouting,
  ...workflowCspOneAvailabilityRouting,
  ...workflowCspOneTariffRouting,
  ...WorkflowCspOneTariffOrderCancelRouting,
  ...workflowCspOneCancelPhonenumberRouting,
  ...workflowCspAiTariffRouting,
  ...WorkflowCspAiTariffOrderCancelRouting
]